export const ApiApplications = {
    getByCandidate: params => ({
        url: '/getApplicationsByCandidate',
        method: 'GET',
        params
    }),
    cancelApplication: (id, data) => ({
        url: '/cancelApplication',
        method: 'POST',
        data: {
            application_id: id,
            ...data
        }
    })
};